module.exports = __webpack_public_path__ + "static/img/appsMockupLeft.1c58c43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/appsMockupLeft.png
// module id = CIJ+
// module chunks = 0